// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"2e3ad263","581":"fed1e0c9"}[chunkId] + ".chunk.js";
};